module.exports = __webpack_public_path__ + "fonts/effect-mutant-agenda-2ae268.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-mutant-agenda.svg
// module id = 795
// module chunks = 0